function getDevice() {
  const ua = navigator.userAgent.toLowerCase()

  const mobile = /iphone|ipod|android.*mobile|windows phone/i.test(ua)
  const tablet = /ipad|android(?!.*mobile)/i.test(ua)
  const desktop = !mobile && !tablet

  return { mobile, tablet, desktop }
}

export default {
  install(Vue) {
    const device = getDevice()
    Vue.prototype.$device = device
  }
}